<div class="doughnut-chart">
  <div class="chart-container d3-chart" #doughnutChart>
  </div>
  <div class="doughnut-per">
  <span *ngIf="percentage != null">{{percentage | roundOff}}%</span>
  </div>

  <div class="chart-label"><span *ngIf="label">{{label}}</span></div>
</div>